module.exports = __webpack_public_path__ + "static/img/homeBg.ed37c75b.png";